import { RoomInterface } from './../types/talkRoomTypes';
import { GET_TALKROOM } from '../constants/index'

export const getTalkRoom = (payload: RoomInterface) => {
  return {
    type: GET_TALKROOM,
    payload
  }
}
